// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__k0Nh-","block":"styles_block__487u-"};